export default __webpack_public_path__ + "static/media/people.a1d83f15.svg";